// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"69cc6415","453":"ec030a81","613":"66533125"}[chunkId] + ".chunk.js";
};